import { Braces, Coins, DownloadCloud, Paintbrush, PlayCircle, Plug, Settings } from 'lucide-react';
import type { ReactNode } from 'react';
import { paths } from 'src/config/paths';

export interface RailItem {
  title: string;
  icon: ReactNode;
  path: string;
  external?: boolean;
}

// The layer that exists exactly once regardless of how many products a project
// runs. It sits at the foot of the rail rather than inside a product's nav, so
// no product appears to own it.
export const sharedRailItems = (slug: string): RailItem[] => [
  {
    title: 'Incentives',
    icon: <Coins size={20} />,
    path: paths.project.incentives.home(slug),
  },
  {
    title: 'Triggers',
    icon: <PlayCircle size={20} />,
    path: paths.project.triggers.home(slug),
  },
  {
    title: 'Data',
    icon: <DownloadCloud size={20} />,
    path: paths.project.dataExport(slug),
  },
  {
    title: 'Page customization',
    icon: <Paintbrush size={20} />,
    path: paths.project.customize(slug),
  },
  {
    title: 'Developer guide',
    icon: <Braces size={20} />,
    path: 'https://docs.fuul.xyz/developer-guide/getting-started-with-fuul-web-sdk',
    external: true,
  },
  {
    title: 'MCP server',
    icon: <Plug size={20} />,
    path: 'https://docs.fuul.xyz/fuul-mcp-server/quickstart',
    external: true,
  },
  {
    title: 'Settings',
    icon: <Settings size={20} />,
    path: paths.project.settings(slug),
  },
];
